import { createContext } from 'react';
import { IGlobalDetail } from './globalDetail';

export type GlobalDetailContextProps = {
  globalDetail: IGlobalDetail;
  setGlobalDetail: Function;
};

export const GlobalContext = createContext({} as GlobalDetailContextProps);
